import { get } from '@/api/base'

export const getContainerGroupsForCompany = async companyUuid => {
  const response = await get({
    path: `admin/container_groups`,
    params: { company_uuid: companyUuid },
  })
  return response.success ? response.data.container_groups : []
}
